import { BotWidget } from './BotWidget'

export { BotWidget }
export type {
  BotToParentMessage,
  BotWidgetConfig,
  BotWidgetInit,
  MiniChatWindowMessage,
  ParentToBotMessage,
  ParentToQuickHelpMessage,
  QuickHelpParams,
  WidgetCorner,
} from './types'

// Preserves the original CDN-script contract: <script src="chatui-widget.js">
// followed by `new BotWidget({...})` / `window.BotWidget`. Only meaningful
// for the IIFE build (vite.lib.config.ts) — a no-op under the ES build.
declare global {
  interface Window {
    BotWidget: typeof BotWidget
  }
}
if (typeof window !== 'undefined') {
  window.BotWidget = BotWidget
}
